import { Button,} from 'alm-react-components';
import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";
import {useNavigate} from 'react-router-dom';
import {useEffect, useState} from 'react';
import {apis} from '../../../services/alm';

function About() {
  const navigate = useNavigate();
  const [, setNewVideos] = useState([]);
  const getAllNewVideos = async () => {
    try {
      const response = await apis.fetchNewVideos();
      setNewVideos(response?.data);
    } catch (error) {
      console.log('error', error);
    }
  };
  
  useEffect(() => {
    getAllNewVideos();
  }, []);
  return (
    <>
      <div className="px-6 lg:px-8 xl:pr-32 xl:pl-32 pt-6 md:py-14 w-[100%] md:px-8 mb-12 flex-grow ">
        <div className="flex justify-between items-center">
          <Button
            onClick={() => navigate(`/home/library`)}
            variant="default"
            className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0 mr-3 mt-[2px]"
            >
              <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
          </Button>
          
        </div>

        <div className="w-[100%] mx-auto py-6 md:py-7">
          <div className="lg:flex lg:items-center lg:justify-between mb-4 md:mb-0">
            <div className="min-w-0 flex-1  md:pb-10">
              <h1 className="scroll-m-20 tracking-tight leading-7 text-2xl lg:text-3xl xl:text-4xl font-barlowLight font-light">
                About
              </h1>
            </div>
          </div>
          <div className="lg:flex lg:items-center lg:justify-between mb-4 md:mb-0">
            <div className="min-w-0 flex-1  md:pb-10">
              <p className="leading-7 text-base pb-7">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
              </p>

              <h4 className=" text-lg font-opensansSemiBold">Duis aute irure </h4>
              <p className="leading-7 text-base pb-7">
                Dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                pariatur.
              </p>
              <p className="leading-7 text-base pb-7">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium
                doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore
                veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam
                voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur
                magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est,
                qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non
                numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat
                voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis
                suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum
                iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur,
                vel illum qui dolorem eum fugiat quo voluptas nulla pariatur
              </p>

              <h4 className=" text-lg font-opensansSemiBold">Excepteur sint</h4>
              <p className="leading-7 text-base pb-7">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
                deserunt mollit anim id est laborum.
              </p>
              <p className="leading-7 text-base pb-7">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium
                doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore
                veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam
                voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur
                magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est,
                qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non
                numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat
                voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis
                suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum
                iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur,
                vel illum qui dolorem eum fugiat quo voluptas nulla pariatur
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
